import { useState } from "react";
import axios from "../axios";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Erreur serveur, veuillez réessayer.");
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "#f8fafc", padding: "24px"
    }}>
      <ToastContainer theme="colored" />
      <div style={{
        maxWidth: "400px", width: "100%", background: "white",
        borderRadius: "16px", padding: "32px",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)"
      }}>
        {sent ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>📧</div>
            <h2 style={{ color: "#166534", marginBottom: "8px" }}>Email envoyé !</h2>
            <p style={{ color: "#475569", fontSize: "14px", marginBottom: "24px" }}>
              Si cet email est associé à un compte, vous recevrez un lien dans quelques minutes.
            </p>
            <Link to="/login" style={{ color: "#e11d48", fontWeight: 600, textDecoration: "none" }}>
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <h2 style={{ marginBottom: "8px", color: "#1e293b" }}>Mot de passe oublié</h2>
            <p style={{ color: "#64748b", fontSize: "14px", marginBottom: "24px" }}>
              Entrez votre email et nous vous enverrons un lien de réinitialisation.
            </p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Votre email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: "100%", padding: "12px 16px", borderRadius: "8px",
                  border: "1.5px solid #e2e8f0", fontSize: "15px",
                  outline: "none", boxSizing: "border-box", marginBottom: "16px"
                }}
              />
              <button
                type="submit"
                style={{
                  width: "100%", padding: "13px", background: "#e11d48",
                  color: "white", border: "none", borderRadius: "8px",
                  fontWeight: 700, fontSize: "15px", cursor: "pointer",
                  marginBottom: "16px"
                }}
              >
                Envoyer le lien
              </button>
            </form>
            <p style={{ textAlign: "center", fontSize: "13px", color: "#64748b" }}>
              <Link to="/login" style={{ color: "#e11d48", textDecoration: "none" }}>
                Retour à la connexion
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
